import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";

import ProtectedRoute from "./components/Auth/ProtectedRoute";
import ProformaValidation from "./pages/ProformaValidation";

const LandingPage = lazy(() => import("./pages/LandingPage"));
const Contact = lazy(() => import("./pages/Contact"));
const WhyChooseUs = lazy(() => import("./pages/WhyChooseUs"));
const Login = lazy(() => import("./pages/Auth/Login"));
const Register = lazy(() => import("./pages/Auth/Register"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const AccountantDashboard = lazy(() => import("./pages/accountant/Dashboard"));
const ManagerDashboard = lazy(() => import("./pages/manager/dashboard"));
const Products = lazy(() => import("./pages/Products/Products"));
const Orders = lazy(() => import("./pages/Orders/Orders"));
const Profile = lazy(() => import("./pages/Profile"));

const AnimatedRoutes: React.FC = () => {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/pourquoi-nous-choisir" element={<WhyChooseUs />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/accountant/dashboard"
          element={
            <ProtectedRoute requiredRole="comptable">
              <AccountantDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manager/dashboard"
          element={
            <ProtectedRoute requiredRole="responsable_production">
              <ManagerDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/products"
          element={
            <ProtectedRoute>
              <Products />
            </ProtectedRoute>
          }
        />
        <Route
          path="/orders"
          element={
            <ProtectedRoute>
              <Orders />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route path="/valider-proforma/:token" element={<ProformaValidation />} />
      </Routes>
    </Suspense>
  );
};

export default AnimatedRoutes;
